import EngagementsSection from "@/components/sections/EngagementsSection";
import CTABand from "@/components/sections/CTABand";
import Reveal from "@/components/Reveal";

export default function Engagements() {
  return (
    <div data-testid="page-engagements">
      <section className="bg-ink-0 relative overflow-hidden">
        <div className="absolute inset-0 glow-soft pointer-events-none" aria-hidden="true" />
        <div className="container-edge pt-20 lg:pt-28 pb-12 relative z-10">
          <Reveal>
            <div className="eyebrow">Scientific engagements</div>
            <h1 className="font-serif font-normal text-4xl md:text-5xl lg:text-[5rem] leading-[1.05] tracking-tight mt-4 text-parchment-bright max-w-5xl">
              Methodology examined in public.
            </h1>
            <p className="mt-7 max-w-3xl text-parchment/75 text-lg leading-relaxed">
              Voice2Evidence is informed by scientific work presented across forums where patient experience, HEOR, market access, and real-world evidence are debated — including ISPOR, AMCP, the World EPA Congress, and the Journal of Clinical Oncology.
            </p>
          </Reveal>
        </div>
      </section>

      <EngagementsSection />

      <CTABand />
    </div>
  );
}
